import { CompanyDto } from './company.model';
import { CountryDto } from './country.model';
import { DriverDto } from './driver.model';
import { VehicleDto } from './vehicle.model';

export interface OrderDto {
  id: number;
  orderId: string;
  driver: DriverDto;
  vehicle: VehicleDto;
  status: OrderStatuses;
  vehicleExtra?: VehicleDto;
  internalOrderId?: string;
  externalOrderId?: string;
  dateFrom?: string;
  timeFrom?: string;
  dateTo?: string;
  timeTo?: string;
  token?: string;
  sharedId?: number;
  duration?: number;
  distance?: number;
  startPoint?: string;
  endPoint?: string;
  show?: boolean;
  eta: string;
}

export interface OrderShareDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  internalOrderId: string;
  externalOrderId: string;
  token: string;
  shared: CompanyDto;
  order: OrderDto;
  reShared: boolean;
}

interface BaseDateTime {
  dateFrom?: string;
  timeFrom?: string;
  dateTo?: string;
  timeTo?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface OrderRequest extends BaseDateTime {
  driverId: number;
  vehicleId: number;
  id?: number;
  orderId?: string;
  internalOrderId?: string;
  vehicleExtraId?: number;
}

export interface OrderPointBase extends BaseDateTime {
  id: number;
  type: PointType;
  activityType?: PointActivityType;
  status?: PointStatuses;
  city?: string;
  address?: string;
  addressNote?: string;
  achieveDescription?: string;
  achieved?: boolean;
  achievedAt?: string;
  zipCode: string;
  referenceNo?: string;
  description?: string;
  notes?: string;
  sortOrder: number;
  longitude?: number | null;
  latitude?: number | null;
  longitudeFromAddress?: number;
  latitudeFromAddress?: number;
  realLongitude?: number;
  realLatitude?: number;
  orderId?: number;
}

export interface OrderPointDto extends OrderPointBase {
  country: CountryDto;
  countryName?: string;
  tempOrder?: number;
}

export interface OrderPointRequest extends OrderPointBase {
  countryName: string;
}

export interface ShareOrderRequest {
  email: string;
  orderId: number;
}

export interface UnshareOrderRequest {
  id: number;
  orderId: number;
}

export enum PointType {
  START = 'start',
  END = 'end',
  INSIDE = 'inside',
}

export enum PointActivityType {
  LOADING = 'loading',
  UNLOADING = 'unloading',
  INTERMEDIATE_POINT = 'intermediate_point',
  CUSTOMS_CLEARANCE = 'customs_clearance',
  CROSSING = 'crossing',
  OTHER = 'other',
}

export enum PointStatuses {
  READY = 'ready',
  TO_APPROVE = 'to_approve',
  DONE = 'done',
}

export enum OrderStatuses {
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}

export enum OrderType {
  OPEN = 'open',
  CLOSED = 'closed',
}
